"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _ExpandMore = _interopRequireDefault(require("@material-ui/icons/ExpandMore"));

var _core = require("@material-ui/core");

var _useStyles = _interopRequireDefault(require("../useStyles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var Arrows = function Arrows(_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? /*#__PURE__*/_react["default"].createElement(_ExpandMore["default"], null) : /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null);
};

Arrows.propTypes = {
  isOpen: _propTypes["default"].bool.isRequired
};

var ListWithNestedLists = function ListWithNestedLists(_ref2) {
  var underline = _ref2.underline,
      listItemText = _ref2.listItemText,
      nestedItems = _ref2.nestedItems;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var classes = (0, _useStyles["default"])({
    underline: underline
  });
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    component: "li"
  }, /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    button: true,
    className: classes.list,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, /*#__PURE__*/_react["default"].createElement(Arrows, {
    isOpen: isOpen
  }), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    primary: listItemText
  })), /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
    "in": isOpen,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react["default"].createElement(_List["default"], {
    disablePadding: true
  }, nestedItems.map(function (_ref3) {
    var text = _ref3.listItemText,
        onClick = _ref3.onClick;
    return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
      key: text,
      onClick: onClick,
      className: classes.list,
      tabIndex: 0
    }, /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
      primary: text,
      className: classes.nestedItems
    }));
  }))));
};

ListWithNestedLists.defaultProps = {
  underline: false,
  nestedItems: []
};
ListWithNestedLists.propTypes = {
  underline: _propTypes["default"].bool,
  listItemText: _propTypes["default"].string.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  nestedItems: _propTypes["default"].array
};
var _default = ListWithNestedLists;
exports["default"] = _default;